<template>
  <main class="dark:bg-black dark:text-gray-200">
        <HeaderComponent />
        <div class="h-[50vh] flex items-end sm:items-center justify-start bg-no-repeat bg-fixed bg- lg:bg-right" :style="{ 'background-image': 'url(' + backgroundImage + ')' }">
            <div class="bg-white max-w-xl p-4 sm:p-8 select-none ">
                <h2 class="font-bold tracking-tight text-xl sm:text-4xl">
                    Especialização em Trauma do Esporte EAD
                </h2>
                <p class="mt-8 max-w-lg text-gray-500 text-sm">
                    <span class="font-bold">Seja bem vindo ao Curso de Especialização em Trauma do Esporte, da Unifesp.</span><br/>
                    Coordenado pelos professores Carlos Vicente Andreoli, Alberto de Carlos Pochini, Benno Ejnisman e Paulo
                    Belangero, este curso Lato Sensu tem carga horária de 384 horas e tem 
                    <span class="font-bold">início no dia 18 de março de 2024</span> e 
                    <span class="font-bold">término em 16 de março de 2025</span>.
                </p>
            </div>
        </div>
        <BannerCarousel class="hidden" />
        <div class="h-full bg-gray-100 mx-auto py-10 sm:py-20 dark:bg-gray-700">
            <CarouselDisciplinas class="lg:col-span-2" />
        </div>
        <section class="container min-w-full py-12">
            <CarouselVideosAssistidos v-if="$store.state.user.user" class="mt-1"/>
            <ListSubjects class="py-2 mb-2"/>
        </section>
  </main>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';
  import HeaderComponent from '@/components/HeaderComponent.vue';
  import BannerCarousel from '@/components/BannerCarouselComponent.vue';
  import ListSubjects from '@/components/ListSubjects.vue';
  import CarouselVideosAssistidos from '@/components/CarouselVideosAssistidos.vue';
  import CarouselDisciplinas from '@/components/CarouselDisciplinas.vue';
  import 'vue3-carousel/dist/carousel.css'
  import banner from '@/assets/banner.jpg'

  export default {
        name: 'HomeView',
        data(){
            return {
                backgroundImage: banner,
            }
        },
        components: {
            HeaderComponent,
            BannerCarousel,
            ListSubjects,
            CarouselVideosAssistidos,
            CarouselDisciplinas
        },
        mounted() {
            window.scrollTo(0, 0);
            if(this.getSubjects == undefined || this.getSubjects.length == 0) this.fetchSubjects({keyword: ''})

        },
        methods: {
            ...mapActions(['fetchSubjects']),
        },
        computed: {
            ...mapGetters(['getSubjects']),
        }
}
</script>